import { Wrench } from 'lucide-react';
import { DEFAULT_MAINTENANCE_MESSAGE } from '@/hooks/useMaintenanceStatus';
import { BRAND_HERO_GRADIENT } from '@/lib/brand';

interface MaintenancePageProps {
  message?: string | null;
}

/**
 * Tela exibida ao assinante quando o sistema está em modo de manutenção.
 * O card usa o gradiente verde-petróleo da identidade (escuro no topo) para que
 * a logo verde apareça com bom contraste. A página volta ao ar sozinha quando
 * a manutenção é desativada — sem o usuário precisar recarregar.
 */
export default function MaintenancePage({ message }: Readonly<MaintenancePageProps>) {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-background px-4 py-10">
      {/* brilho verde sutil ao fundo */}
      <div className="pointer-events-none absolute -top-24 -right-24 h-72 w-72 rounded-full bg-primary/15 blur-3xl" />

      <div
        className="relative w-full max-w-lg overflow-hidden rounded-2xl border border-[#00433d] p-10 text-center text-white shadow-xl sm:p-12"
        style={{ background: BRAND_HERO_GRADIENT }}
      >
        <div className="relative">
          <img src="/logo-librattum.png" alt="Librattum" className="mx-auto mb-7 h-12 w-auto" />

          <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-white/15 text-white">
            <Wrench className="h-10 w-10" />
          </div>

          <h1 className="text-3xl font-bold tracking-tight text-white">Estamos em manutenção</h1>

          <p className="mx-auto mt-4 max-w-md text-base leading-7 text-white/90">
            {message || DEFAULT_MAINTENANCE_MESSAGE}
          </p>
        </div>
      </div>
    </div>
  );
}
